export const sha256 = async (value: string): Promise<string> => {
  if (!value || !window.crypto?.subtle) return ''

  const data = new TextEncoder().encode(value)
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', data)

  return Array.from(new Uint8Array(hashBuffer))
    .map((byte) => byte.toString(16).padStart(2, '0'))
    .join('')
}
